module.exports = __webpack_public_path__ + "img/2025-3.d8054fd5.jpg";